var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPclServiceBusRepair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0069b1",
    d: "M18 9.5H6v-4h12m-1.5 10c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5m-9 0c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5S9 13.2 9 14s-.7 1.5-1.5 1.5m-3.5-1c0 .9.4 1.7 1 2.2v1.8h3v-1h8v1h3v-1.8c.6-.5 1-1.3 1-2.2v-9c0-3.5-3.6-4-8-4s-8 .5-8 4v9m0 4.01h16v1.99h-7v3h-2v-3H4v-1.99z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPclServiceBusRepair);
export default __webpack_public_path__ + "static/media/PclServiceBusRepair.34801a042c0f6cc151bd3731b964d447.svg";
export { ForwardRef as ReactComponent };